import React, { useState, useCallback, useEffect } from 'react';
import { handleError, ApiError } from '../../../utils/error/error';
import { UserData, User } from '../../../utils/types';
import { getUserData } from '../../../utils/apicall/profileApi';
import NotFound from '../../common/404';
import { CONFIG } from '../../../utils/config';
import GeneralErrorPage from '../../common/general-error';
import { authService } from '../../../utils/authServices';

const ProfileUser: React.FC = () => {
    const [isValidPath, setIsValidPath] = useState(true);
    const [data, setData] = useState<UserData | null>(null);
    const [userdata, setUserData] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const loadData = useCallback(async () => {
        setIsLoading(true); // Set loading to true before fetching data
        try {
            const response = await getUserData();
            if (response) {
                setData(response.data);
                setUserData(response.data);
            } else {
                console.warn('Expected data but got:', response);
            }
        } catch (error) {
            handleError(error);
            if (error instanceof ApiError && error.statusCode === 404) {
                setIsValidPath(false);
            } else {
                console.error('An unexpected error occurred:', error);
            }
        } finally {
            setIsLoading(false); // Set loading to false once the fetch is complete
        }
    }, []);

    useEffect(() => {
        loadData();
        authService.getTokenExpiration();
    }, [loadData]);

    if (!isValidPath) {
        return <NotFound />;
    }

    if (isLoading) {
        return (
            <div className="loading-screen">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <section className="main-page">
            <div className="content">
                <section className="ontotita py-5">
                    <div className="container mt-4">
                        <div className="card p-5">
                            <h2 className="h5 mb-4 text-primary">Προφίλ Χρήστη</h2>
                    
                            {/* Full Name */}
                            <div className="mb-3">
                                <label className="form-label">Ονοματεπώνυμο:</label>
                                <p className="fs-5 fw-bold text-secondary">
                                    {userdata?.name ?? '-'}
                                </p>
                            </div>

                            {/* Email */}
                            <div className="mb-3">
                                <label className="form-label">Email:</label>
                                <p className="fs-5 fw-bold text-secondary">
                                    {userdata?.email ?? '-'}
                                </p>
                            </div>

                            {/* Accessible Units */}
                            <div className="mb-3">
                                <label className="form-label">Μονάδες που έχει πρόσβαση:</label>
                                <ul className="list-group">
                                    {userdata?.units && userdata.units.length > 0 ? (
                                        userdata.units.map((unit) => (
                                            <li key={unit.id} className="list-group-item">
                                                <i className="bi bi-building me-2"></i> {unit.title}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="list-group-item">Δεν υπάρχουν διαθέσιμες μονάδες.</li>
                                    )}
                                </ul>
                            </div>

                            {/* Edit Profile Button */}
                            <div className="text-end mt-4">
                                <a href={CONFIG.urls.getProfileEditUrl()} className="btn btn-warning">
                                    Επεξεργασία Προφίλ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    );
};

export default ProfileUser;
